/* variables declarations */

var header_selector = 'header.banner';
var header_bg_class = 'header__bg';
var header_sticky_class = 'header__sticky';
var headerTop = '';

/*equal height div based on class*/
function setDivHeight(selector) {
    var ele = jQuery(selector);
    ele.height('auto');
    var highest = null;
    var max_height = 0;
    ele.each(function () {
        var section_height = jQuery(this).height();
        if (section_height > max_height) {
            max_height = section_height;

        }
    });
    ele.height(max_height);

}

function showDivesOnLoad(selector, type) {
    var total_cards = jQuery(selector).find(".kc-cards").size();


    var cards = jQuery(selector).find(".kc-cards:gt(2)");
    var size = cards.size();

    cards.each(function (index, value) {
        jQuery(this).css('display', 'none');
    });

    if (total_cards > 3) {
        jQuery(selector + ' .see-more-link a').removeClass('hide');
    } else {
        jQuery(selector + ' .see-more-link a').addClass('hide');

    }
    setDivHeight(selector + ' .kc-cards');
}

function showMoreDivesOnLoad(tabid) {
    var cards = jQuery('#' + tabid).find('.kc-cards');
    var size = cards.size();
    cards.each(function (index, value) {
        if (!jQuery(this).is(':visible')) {
            jQuery(this).css('display', 'inline-block');
        }
    });

}


function setCardHeight(selector1, selector2) {
    if (jQuery(selector1).length > 0) {
        setDivHeight(selector1);
        setDivHeight(selector2);
    }
}
function cookieUniqueName() {
    var notificationselector = jQuery('.notification');
    if (notificationselector.length > 0 && notificationselector.children('section').length > 0) {
        var name = jQuery(".notification").children('section').attr('class');
        name = name.replace(/\s/g, '');
        return name;
    }
}
/* add/remove sticky class to header */
function stickyToHeader() {
    if (jQuery(window).scrollTop() > (headerTop) || jQuery(window).scrollTop() > 50) {
        jQuery(header_selector).addClass(header_sticky_class);
    } else {
        jQuery(header_selector).removeClass(header_sticky_class);
    }
}


/*view port width and height on load*/
function viewportWidhOnLoad() {
    var e = window;
    var a = 'inner';
    if (!( 'innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return {width: e[a + 'Width'], height: e[a + 'Height']};
}

function monthDropDown() {
    jQuery('.exp_months ul').addClass('dropdownhidden').removeClass('dropdownvisible');
    jQuery('.exp_months').find('a:first').addClass('trigger').removeClass('activetrigger');
}

function yearDropDown() {
    jQuery('.exp_years ul').addClass('dropdownhidden').removeClass('dropdownvisible');
    jQuery('.exp_years').find('a:first').addClass('trigger').removeClass('activetrigger');
}

/*equal div height function for child div*/
function equalHeightForChild(parentSelector,childSelector) {
    var maxHeight = 0;
    jQuery(parentSelector).each(function() {
        jQuery(this).find(childSelector).height('auto');

        jQuery(this).find(childSelector).each (function(index) {
            if (jQuery(this).height() > maxHeight) {
                maxHeight = jQuery(this).height();
            }
        });
        jQuery(this).find(childSelector).height(maxHeight);
    });
}

jQuery(document).ready(function ($) {


    /* onload header position */
    if (jQuery(header_selector).length > 0) {
        headerTop = jQuery(header_selector).offset().top;
        stickyToHeader();
    }




    /*check if cookie is set for notification*/

    var name = cookieUniqueName();
    if (document.cookie.indexOf(name + '=') === -1 && jQuery(".notification").children('section').length > 0) {
        $(".notification").removeClass('hide');
        $("body").addClass('notification-open');
    }

    //notfication bar slide up and set cookie on close
    $(".notificationclose").on("click", function () {
        $(".notification").slideUp();
        $("body").removeClass('notification-open');
        date = new Date();
        date.setTime(date.getTime() + (5 * 24 * 60 * 60 * 1000));
        expires = date.toGMTString();

        name = cookieUniqueName();
        document.cookie = name + " = ytrie; expires=" + expires + "; path=/";

    });

    $(".clients").on("click", function () {

        /* toggle class for background color */
        if ($(header_selector).hasClass(header_bg_class)) {
            $(".clients-tabs").slideUp('slow', function () {
                $(header_selector).removeClass(header_bg_class);
                $(".clients").removeClass("active");
            });
        } else {
            $(header_selector).addClass(header_bg_class);
            $(".clients").addClass("active");
            $(".clients-tabs").slideDown('slow');
        }

    });

    // if click  outside the section menu
    $(".clients-tabs").slideUp();

    $('html').click(function (e) {
        if (e.target.id !== 'clients' && $(e.target).parents('#main-menu-tabs').length === 0) {
            $(".clients-tabs").slideUp('slow', function () {
                $(".clients").removeClass("active");
                $(header_selector).removeClass(header_bg_class);
            });

        }

        if (e.target.id !== 'callbackid' && $(e.target).parents('#callbackid').length === 0 && e.target.id !== 'nf-field-7') {
            $(".callback").parent(".calback-wrapper").removeClass("pop-up");
        }

        var searchcontainer = $('.search-form-container div.search-link');
        var searchFormContainer = $('.search-form-container .search-form input');
        if (!searchcontainer.is(e.target) && searchcontainer.has(e.target).length === 0 && (!searchFormContainer.is(e.target) && searchFormContainer.has(e.target).length === 0)) {
            //$(".menu-links-section .menu-links").removeClass('menu-hide');
            $(".menu-main-menu-container").removeClass('menu-hide');
            $(".search-form-container div.search-link").removeClass('open');
            $(".search-form-container .search-form ").removeClass('open-form');
            $(".menu-links").removeClass('menu-hide');
        }

    });

    $(".callback").on("click", function () {
        $(".callback").addClass("active-btn").parent(".calback-wrapper").toggleClass("pop-up");
    });

    /* search form on header */


    $(".search-form-container div.search-link").click(function () {
        $(".menu-links-section .menu-links").toggleClass('menu-hide');
        //$(".menu-main-menu-container").toggleClass('menu-hide');
        $(".search-form-container .search-form ").toggleClass('open-form');
        //$(".search-form-container .search-form input").focus();
        $(".search-form-container div.search-link").toggleClass('open');
        /* $(".search-form-container .search-form").animate({width: "toggle"});*/
    });


    $('div.kr-tabs-home ul.kc_tabs_nav li a').click(function (event) {
        var href1 = $(this).attr('href');
        /* showDivesOnLoad(href1);*/
    });


    $('.see-more-link a').click(function (event) {
        event.preventDefault();
        var tabid = $(this).data("kr-tab");
        showMoreDivesOnLoad(tabid);
        /*$('.see-more-link a').addClass('hide');*/
        $(this).addClass('hide');
    });

    /*homepage channels block equalheight*/
    setDivHeight('.all-channels__single-column');


    /* animate sections as per viewport comming */
    if (jQuery('.karix-animation').length > 0) {
        jQuery('.karix-animation').viewportChecker({
            classToAdd: 'visible animated fadeInUp',
            offset: 2
        });
    }


    /*set same height of servcices div */
    setDivHeight('#services .kc-cards');


    /*our location slider on about us page*/

    var sliderSelector = jQuery('#OurLocations .krx-our-location-wrapper .kc-col-inner-container:first');

    if ($('#OurLocations').length > 0 && sliderSelector.length > 0) {

        enquire.register('screen and (max-width: 767px)', {
            match: function () {
                if (!sliderSelector.hasClass('slick-initialized')) {
                    sliderSelector.slick({
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    });
                }
            },
            unmatch: function () {

                if (sliderSelector.hasClass('slick-initialized')) {
                    sliderSelector.slick('unslick');
                }
            }
        });
    }


    var kcSliderSelector = jQuery('.kc_case_study_slider');

    /* overlay popup close button */
    if (jQuery('#overlay-popup').length > 0) {
        jQuery("#overlay-popup .close-overlay-popup").click(function () {
            jQuery('#overlay-popup').fadeOut();
            if (jQuery('#overlay-popup .youtube-iframe iframe').length > 0) {
                // changes the iframe src to prevent playback or stop the video playback in our case
                jQuery('#overlay-popup .youtube-iframe iframe').each(function (index) {
                    jQuery(this).attr('src', jQuery(this).attr('src'));
                    return false;
                });
            }
        });
    }

    /*past event*/

    var sessionSelector = '.event_schedule_addon';
    var sessionBtnSelector = '.see-all-sessions';


    if ($(sessionSelector).length <= 2) {
        $(sessionBtnSelector).addClass('hide');
    } else {
        $(sessionSelector).each(function (index) {

            if (index > 1) {
                $(this).addClass('hide');
            }
        });

        $(sessionBtnSelector).click(function () {
            $(sessionSelector).removeClass('hide');
            $(this).addClass('hide');
        });

    }

    /*apply job outside close */
    jQuery(document).click(function (e) {
        if (jQuery(e.target).closest('.exp_months').length === 0) {

           monthDropDown();
        }
        if (jQuery(e.target).closest('.exp_years').length === 0) {
            yearDropDown();

        }

        if (jQuery(e.target).closest('.department').length === 0) {
            jQuery('.department ul').addClass('dropdownhidden').removeClass('dropdownvisible');
            jQuery('.department').find('a:first').addClass('trigger').removeClass('activetrigger');
        }
    });


    /* cf7 responce popup */
    if (jQuery('div.cf7-popup-wrapper').length > 0) {
        jQuery("div.cf7-popup-wrapper .cf7-popup-close").click(function () {
            jQuery('div.cf7-popup-wrapper').dialog('close');
            return false;
        });
    }


    $('html').click(function (event) {

        if (!$(event.target).hasClass("activetrigger")) {
            $(".activetrigger").trigger("click");
        }

    });

    /**/
    var descSelector =   '.industry-accordions .accordion-desc';
    var descTitle =   '.industry-accordions .accordion-title';
    $(descSelector).first().css('display', 'block');
    $(descTitle).first().addClass('ui-state-active');
    $(".industry-accordions .kc_accordion_section").first().addClass('kc-section-active');
    $(descTitle).click(function () {
        $(this).next(".accordion-desc").slideToggle("slow").siblings(".accordion-desc:visible").slideUp("slow");
        $(this).parent().toggleClass("kc-section-active");
        $(this).parent().siblings(".kc_accordion_section").removeClass("kc-section-active");

        $(descSelector).css('display', 'none');
        $(this).siblings('.accordion-desc').css('display', 'block');

        $(descTitle).removeClass('ui-state-active');
        $(this).toggleClass('ui-state-active');
    });

    /*disabled search option when input text is empty*/
    $('.search-form #s, .custom-post-listing-search .input-custom-search').keypress(function (event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode === 13) {
            if ($(this).val().length === 0) {
                event.preventDefault();
            }
        }
    });


});


jQuery(window).scroll(function () {
    stickyToHeader();
});


jQuery(document).on('nfFormReady', function (e, layoutView) {

    /* newsletter form remove error on focus out */
    jQuery('#nf-error-39,#nf-form-errors-5').hide();
    jQuery('.newsletter-loading').hide();

    jQuery('#nf-form-5-cont input:not([type=button])').keydown(function (e) {
        jQuery('#nf-form-errors-5').show();
        jQuery('#nf-form-5-cont .submit-container input[type=button]').prop("disabled", false);
        if (e.keyCode === 13) {
            /*jQuery('.newsletter-loading').show();*/
            jQuery('#nf-form-5-cont .submit-container input[type=button]').click();
        }
    });


    var last_error_html = '';

    jQuery('#nf-form-8-cont input:not([type=button])').keypress(function (e) {

        jQuery('#nf-form-errors-8').show();


    });
    var nameSelector = jQuery('#nf-field-48');
    var emailSelector = jQuery('#nf-field-49');
    var phoneSelector = jQuery('#nf-field-56');

    nameSelector.addClass('ng-name');
    emailSelector.addClass('ng-email');
    phoneSelector.addClass('ng-phone');

    if (jQuery('.ng-name').length === 1) {

        nameSelector.after('<span class="bar"></span><label class="ng-name">Name</label>');
    }
    if (jQuery('.ng-email').length === 1) {
        emailSelector.after('<span class="bar"></span><label class="ng-email">Email</label>');
    }
    if (jQuery('.ng-phone').length === 1) {
        phoneSelector.after('<span class="bar"></span><label class="ng-phone">Phone</label>');
    }
    jQuery('.ninja-forms-field').focus(function () {
        jQuery(this).siblings('label').addClass('active');
    }).blur(function () {
        jQuery(this).siblings('label').removeClass('active');

        if (jQuery(this).val().length > 0) {
            jQuery(this).siblings('label').addClass('content');
        } else {
            jQuery(this).siblings('label').removeClass('content');
        }
    });


    jQuery('#nf-field-51-container').on('click', function () {
        jQuery('#nf-error-48, #nf-error-49, #nf-error-56').show();
    });
    nameSelector.blur(function () {
        if (jQuery(this).val().length <= 0) {
            jQuery('#nf-error-48').hide();
            jQuery('#nf-field-51').prop("disabled", false);
        }
    });

    emailSelector.blur(function () {
        if (jQuery(this).val().length <= 0) {
            jQuery('#nf-error-49').hide();
            jQuery('#nf-field-51').prop("disabled", false);
        }
    });

    phoneSelector.blur(function () {
        if (jQuery(this).val().length <= 0) {
            jQuery('#nf-error-56').hide();
            jQuery('#nf-field-51').prop("disabled", false);
        }
    });

    phoneSelector.keyup(function (event) {
        var errorDiv = jQuery('#nf-error-56');

        var inputVal = jQuery(this).val();
        var regex = /^\d{6,10}$/g;
        if (inputVal.length > 0) {
            errorDiv.empty();
            if (inputVal.match(regex)) {
            } else {
                var errorEle = '<div class="nf-error-msg nf-error-required-error">Please enter valid phone number</div>';
                errorDiv.append(errorEle);
            }
        }
    });

    jQuery('#nf-field-51').off().on('click', function () {
        jQuery('#nf-error-56').empty();

    });

});

jQuery(document).on('nfFormSubmitResponse', function (e, response) {
    if (response.id === 5 && response.response.errors.length <= 0) {
        jQuery('.newsletter-loading').hide();
        setTimeout(function () {
            jQuery("#nf-form-5-cont .nf-response-msg p").fadeOut().empty();
        }, 5000);
    }
});

jQuery(window).resize(function ($) {

    /*homepage channels block equalheight*/
    setDivHeight('.all-channels__single-column');

    /*set same height of servcices div */
    setDivHeight('#services .kc-cards');


    /*setDivHeight('.kc_card_slider .kc_card_single_slide');*/
    


    /*setDivHeight('.kc_case_study_single_slider');*/

   /* if (jQuery('#services').length > 0) {
    showDivesOnLoad('#services');
}
    if (jQuery('#products').length > 0) {
        showDivesOnLoad('#products');
    }
    if (jQuery('#platforms').length > 0) {
        showDivesOnLoad('#platforms');
    }*/

    /*equal height for kc card slider */
    equalHeightForChild('.kc_card_slider','.kc_card_single_slide');
});

jQuery(window).load(function () {
    /* homepage tabs */

    if (jQuery('#services').length > 0) {
        /*showDivesOnLoad('#services');*/
    }
    if (jQuery('#services1').length > 0) {
        showDivesOnLoad('#services1');
    }
    if (jQuery('#products').length > 0) {
        showDivesOnLoad('#products');
    }
    if (jQuery('#platforms').length > 0) {
        showDivesOnLoad('#platforms');
    }

    /*equal height for kc card slider */
    equalHeightForChild('.kc_card_slider','.kc_card_single_slide');
});



